import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class AnteilWaermeerzeugerHeizung extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kombination: number | null = null;
    nutzungsart_id: number | null = null;
    waermeerzeuger_heizung_1_id: number | null = null;
    anteil_waermeerzeuger_heizung_1: number | null = null;
    waermeerzeuger_heizung_2_id: number | null = null;
    anteil_waermeerzeuger_heizung_2: number | null = null;
    bemerkung: string | null = null;

    // view fields
    nutzungsart: string | null = null;
    nutzungsart_reihenfolge: number | null = null;
    waermeerzeuger_heizung_1: string | null = null;
    waermeerzeuger_heizung_2: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'AnteilWaermeerzeugerHeizung';
    }
}

export async function createNewAnteilWaermeerzeugerHeizung(): Promise<AnteilWaermeerzeugerHeizung> {
    const model = createModel(AnteilWaermeerzeugerHeizung, {});

    await model.save();
    return model;
}

export class AnteilWaermeerzeugerHeizungCollection extends BaseCollection<AnteilWaermeerzeugerHeizung> {
    protected modelCls = AnteilWaermeerzeugerHeizung;

    public getModelClassName(): string {
        return 'AnteilWaermeerzeugerHeizung';
    }
}
